import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    evento: null,
    clienteNombre: '',
    eventoNombre: '',
    eventoWhapp: false,
    tipoEventoId: 0,
    solicitaCodigoPromocion: false,
    requiereDocumento: false,
    camposAdicionales: [],
    /* Formato de la tabla */
    participantesColumnas: [],  

    ganadores: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    // nombreHabilitado: true,
    // documentoNumeroHabilitado: true,
    // emailHabilitado: true,
    // numeroCelularHabilitado: true,
    // negocioHabilitado: true,
    // cuitNegocioHabilitado: true,
    // numeroClienteHabilitado: true,
    // codigoPromocionHabilitado: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state, eventoId) {
        state.eventoId = eventoId;
        state.evento = null;
        state.clienteNombre = '';
        state.eventoNombre = '';
        state.eventoWhapp = false;
        state.tipoEventoId = 0;
        state.solicitaCodigoPromocion = false; 
        state.requiereDocumento = false; 
        state.camposAdicionales = [];
        state.participantesColumnas = [];

        state.ganadores = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        // state.nombreHabilitado = true;
        // state.documentoNumeroHabilitado = false;
        // state.emailHabilitado = false;
        // state.numeroCelularHabilitado = false;
        // state.negocioHabilitado = false;
        // state.cuitNegocioHabilitado = false;
        // state.numeroClienteHabilitado = false;
        // state.codigoPromocionHabilitado = false;
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento;
        state.clienteNombre = evento.cliente;
        state.eventoNombre = evento.nombre;
        state.tipoEventoId = evento.tipoEventoId;
        state.solicitaCodigoPromocion = (/true/i).test(evento.solicitaCodigoPromocion);
        state.requiereDocumento = (/true/i).test(evento.requiereDocumento);
        state.camposAdicionales = evento.camposAdicionales;
        state.participantesColumnas = evento.participantesColumnas.sort((a, b) => {
            if (a.orden < b.orden) {
                return -1;
            }
            if (a.orden > b.orden) {
                return 1;
            }
            return 0;
        })

        // state.nombreHabilitado = (/true/i).test(evento.solicitaNombre);
        // state.documentoNumeroHabilitado = (/true/i).test(evento.solicitaDocumento);
        // state.emailHabilitado = (/true/i).test(evento.solicitaEmail);
        // state.numeroCelularHabilitado = (evento.tipoEventoId == 1 || (/true/i).test(evento.solicitaTelefono));
        // state.negocioHabilitado = (/true/i).test(evento.participacionNegocios);
        // state.cuitNegocioHabilitado = (/true/i).test(evento.solicitaDocumentoNegocio);
        // state.codigoPromocionHabilitado = (/true/i).test(evento.solicitaCodigoPromocion);
        // state.numeroClienteHabilitado = false;
    },
    'SET_GANADORES' (state, ganadores) {
        state.ganadores = ganadores.map(participante => ({
            ...participante,
            _rowVariant: participante.staff ? 'staff' : ''
        }));

        /* Agregamos la lista de campos adicionales*/
        state.ganadores.forEach(ganador => {
            if (ganador.camposAdicionales) {
                ganador.camposAdicionales.forEach(campoAdicional => {
                    ganador[`cp${campoAdicional.eventoCampoAdicionalId}`] = campoAdicional.valor;
                    
                });
            }
        });
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, list) {
        state.list = list.map(ganador => ({
            ...ganador,
            posicion: ganador.posicionSorteo
        }));
    },
};

const getters = {
    getField,

    list(state) {
        return state.list;
    }
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO', eventoId);

            apiAxios.get(`eventos/${eventoId}`) 
                .then(res => {
                    commit('SET_EVENTO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGanadores ( { commit } ) {
        return new Promise((resolve, reject) => {
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            // if (state.nombre.trim() != '') {
            //     queryString += '&nombre=' + state.nombre.trim();
            // }
            // if (state.documentoNumero.trim() != '') {
            //     queryString += '&documentoNumero=' + state.documentoNumero.trim();
            // }
            // if (state.email.trim() != '') {
            //     queryString += '&email=' + state.email.trim();
            // }
            // if (state.numeroCelular.trim() != '') {
            //     queryString += '&numeroCelular=' + state.numeroCelular.trim();
            // }
            // if (state.negocio.trim() != '') {
            //     queryString += '&negocio=' + state.negocio.trim();
            // }
            // if (state.cuitNegocio.trim() != '') {
            //     queryString += '&cuitNegocio=' + state.cuitNegocio.trim();
            // }
            // if (state.codigoPromocion.trim() != '') {
            //     queryString += '&codigoPromocion=' + state.codigoPromocion.trim();
            // }
            // if (state.numeroCliente.trim() != '') {
            //     queryString += '&numeroCliente=' + state.numeroCliente.trim();
            // }
            
            apiAxios.get(`eventos/${state.eventoId}/ganadores` + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_GANADORES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getList ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get(`eventos/${state.eventoId}/ganadores/list`)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}